import { Col, Row } from "antd";
import Introduce from "./Components/Introduce";

import DopingSections from "./Components/DopingList";

const IntroduceDopingIndex = () => {
  return (
    <>

      <Col xs={24}>
        <Row gutter={[0,20]}>
          <Col xs={24} className="">
            <Introduce />
          </Col>
         
          <Col xs={24}>
            <DopingSections />
          </Col>
         
          
        </Row>
      </Col>
  
    </>
  );
};

export default IntroduceDopingIndex;
